/**
 * @fileoverview GET handler for the "/companies/:company_id/security_settings/security_event_config" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { companiesCompanyIdSecuritySettingsSecurityEventConfig } from "./constants";
import type { CompanySecurityEventConfigResult } from "./types";
import { isCompanySecurityEventConfigResult } from "./validators";

export const getCompanySecurityEventConfig = reactQueryFetcherAdapter(
  companiesCompanyIdSecuritySettingsSecurityEventConfig,
  (
    signal: AbortSignal,
    companyId: string,
    exportWarehouseType: number
  ): Promise<CompanySecurityEventConfigResult> => {
    return fetch(
      `/companies/${companyId}/security_settings/security_event_config`,
      "GET",
      { export_warehouse_type: exportWarehouseType },
      { signal }
    );
  },
  isCompanySecurityEventConfigResult
);
